import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import Row from '@app/components/layout/Row'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import { housingFormTabs, housingFormTabsQueryParamName } from '../constants'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import { pages } from '@app/util/links'
import { labelAddressBuilder } from '@app/util/helpers'

export const HousingFormPageOverview = ({
  housingForm,
}: {
  housingForm: ViewHousingFormModel
}) => {
  const t = useTranslations().app
  return (
    <>
      <SafeHtml html={housingForm?.content} />

      <div>
        <SectionHeader
          title="Uitgelichte initiatieven"
          seeMore={t.common.seeMore}
          toRoute={`?${housingFormTabsQueryParamName}=${housingFormTabs.initiatives}`}
        />
        <Row>
          {housingForm?.initiatives.slice(0, 2)?.map((initiative) => (
            <InitiativeCard
              key={initiative.id}
              to={pages.initiative(initiative.slug)}
              image={initiative.images?.[0]?.src ?? defaultProjectPicture}
              title={initiative.title}
              description={initiative.description}
              location={labelAddressBuilder(
                initiative.location.address,
                t.common.notSpecified,
              )}
              phase={initiative.phase?.name}
              tagText={
                initiative.searchingForMembers
                  ? t.common.initiativeStatus.searchingForMembers
                  : t.common.initiativeStatus.notSearchingForMembers
              }
              tagVariant={initiative.searchingForMembers ? 'green' : 'gray'}
            />
          ))}
        </Row>
      </div>

      <div>
        <SectionHeader
          title="Locaties"
          seeMore={t.common.seeMore}
          toRoute={`?${housingFormTabsQueryParamName}=${housingFormTabs.plots}`}
        />
        <Row>
          {housingForm.plots.slice(0, 2)?.map((plot) => (
            <InitiativeCard
              key={plot.id}
              to={pages.plot(plot.slug)}
              image={plot.media?.[0]?.src ?? defaultProjectPicture}
              title={plot.name}
              description={plot.description}
              location={labelAddressBuilder(
                plot.location.address,
                t.common.notSpecified,
              )}
              tagText={
                t.common.plotApplicationStatus[
                  plot.applicationStatus as keyof typeof t.common.plotApplicationStatus
                ]
              }
              tagVariant={
                plot.applicationStatus === 'applicationOpen' ? 'green' : 'gray'
              }
            />
          ))}
        </Row>
      </div>
    </>
  )
}
